export default __webpack_public_path__ + "static/media/img5.4c877ddd.png";